import styled from 'styled-components';

import {
  AccessTime,
  CalendarTodayOutlined,
  Link,
  ArrowBack,
  Close,
} from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import { wellzTheme as theme } from '@wellz-theme/mui';
import { wellzTheme } from 'theme/index';

import { styled as StyledMui } from '@mui/material/styles';

export const Container = styled.div`
  background-color: white;
  height: 100%;
  width: 600px;

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const DrawerContent = styled.div`
  width: 520px;
  margin: 0 ${theme.spacing(5)};
  display: flex;
  flex-direction: column;
  flex: 1;

  ${theme.breakpoints.down('md')} {
    width: 100%;
    margin: 0px;
    padding: ${theme.spacing(2.5)};
  }
`;

export const Header = styled.div`
  width: 100%;
  padding: ${theme.spacing(2)};
  padding-left: ${theme.spacing(7)};
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${theme.breakpoints.down('md')} {
    padding-left: ${theme.spacing(1.5)};
  }
`;

export const Title = styled(Typography)`
  color: black;
  text-transform: uppercase;
  font-size: 12px;
  line-height: 16px;
`;

export const DrawerTitle = styled(Typography)`
  margin-bottom: ${theme.spacing(1)};
`;

export const DrawerSubtitle = styled(Typography)`
  color: ${wellzTheme.colors.text.disabled};
`;

export const SelectStatusContainer = styled.div`
  display: flex;
  align-items: center;
  margin: ${theme.spacing(4)} 0;
`;

export const InvitationItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: ${theme.spacing(2)} 0;
  border-bottom: 1px solid ${wellzTheme.colors.moduleBorder};
  gap: 4px;
`;

export const InvitationInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const InvitationRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const InvitationDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(0.5)};
`;

export const InvitationName = styled(Typography)`
  color: ${wellzTheme.colors.text.primary};
`;

export const InvitationDate = styled.div`
  display: flex;
  gap: ${theme.spacing(3)};
`;

export const IconAccessTime = styled(AccessTime)`
  height: 20px;
  width: 20px;
  fill: ${wellzTheme.colors.text.disabled};
`;

export const IconCalendar = styled(CalendarTodayOutlined)`
  height: 20px;
  width: 20px;
  fill: ${wellzTheme.colors.text.disabled};
`;

export const IconLink = styled(Link)<{ disabled: boolean }>`
  height: 18px;
  width: 18px;
  fill: ${({ disabled }) =>
    disabled ? wellzTheme.colors.moduleBorder : wellzTheme.colors.primary};
`;

export const TextRow = styled(Typography)`
  color: ${wellzTheme.colors.text.disabled};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

export const InvitationExpiry = styled(Typography)<{ color: string }>`
  color: ${props => props.color};
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  line-height: 0;
`;

export const CopyLinkButton = styled(Button)`
  gap: ${theme.spacing(1)};
  padding: 4px 5px;
`;

export const ScrollToMeForRefetch = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Loading = StyledMui(CircularProgress)(() => ({
  margin: `${theme.spacing(2)} 0px`,

  '& .MuiCircularProgress-circle': {
    color: wellzTheme.colors.primary,
  },
}));

export const LoadingBox = styled(ScrollToMeForRefetch)`
  flex: 1;
`;

export const Empty = styled.div`
  display: flex;
  gap: ${theme.spacing(2)};
  align-items: center;
`;

export const ContainerLoading = styled.div`
  width: 600px;
  display: flex;
  height: 100%;
  background-color: white;
  align-items: center;
  justify-content: center;

  &.MuiCircularProgress-circle {
    color: ${theme.palette.primary.main};
  }
`;
export const ArrowLeftIcon = styled(ArrowBack)`
  fill: ${theme.palette.primary.main};
  width: ${theme.spacing(3)};
  height: ${theme.spacing(3)};
`;

export const CloseIcon = styled(Close)`
  fill: ${theme.palette.primary.main};
  width: ${theme.spacing(3)};
  height: ${theme.spacing(3)};
`;
